import React from 'react';
import {ServerComponentCaller} from "../../helpers";

const LicenciaClaseC = props => <ServerComponentCaller url={"assets/data/pages/licencias/C.json"}/>;

export default LicenciaClaseC;
